<template>
  <!-- 商品详情页面 -->
  <div class="detail-page">
      <div class="img-container" :style="imgStyle" >
          <swiper
            @swiper="onSwiper"
            class="img-swiper" 
            :options="swiperOptions"
            @slideChange="onSlideChange">
            <swiper-slide v-for="(item, index) in product.imageInfo.imageList" :key="index">
              <img ref="detail_img" class="detail-img" :src="item.url" mode=""/>
            </swiper-slide>
            </swiper>
          <div class="image-list-index">
              <span>{{currentIndex + 1}}</span>/{{totalLength}}
          </div>
          <div class="image-list-span">
              <span>此商品正在参加奖励活动</span>
          </div>
      </div>
      <div class="pl10 pr10 detail-card">
          <div class="price-container bg-white">
              <div class="price-and-num">
                  <span class="price-label txt-orange">到手价</span>
                  <span class="new-price txt-orange ml5">￥{{product.priceInfo.lowestPrice}}</span>
                  <span class="old-price ml10">￥<span>{{product.priceInfo.price}}</span></span>
                  <!-- <span class="sale-num arrow">已售{{0}}</span> -->
              </div>
              <div class="coupon-container">
                  <div class="coupon-info">
                      <span class="coupon-item" v-for="(tag, i) in product.skuTagList" :key="i">{{tag.name}}</span>
                  </div>
                  <!-- <div class="coupon-more arrow">
                      <span>查看优惠详情</span>
                  </div> -->
              </div>
          </div>
          <div class="title-container bg-white">
              <div class="good-replay">
                  <span>好评率{{product.goodCommentsShare}}%</span>
                  <span class="ml5">好评数{{product.comments}}</span>
              </div>
              <div class="title-div">
                  <span class="title-txt">{{product.skuName}}</span>
              </div>
          </div>
      </div>
      <!-- 预估收益 -->
      <div class="income-container bg-white">
          <div class="income-label">
              <span>店铺名称</span>
          </div>
          <div class="income-price">
              <span class="txt-orange">{{product.shopInfo.shopName}}</span>
          </div>
      </div>
      <div v-if="loginType === 'up'" class="income-container bg-white">
          <div class="income-label">
              <span>预估收益</span>
          </div>
          <div class="income-price">
              <span class="txt-orange">￥{{ product.commissionInfo.commission }}</span>
              <span class="ml5">( 预计提出{{ product.commissionInfo.commissionShare }}% )</span>
          </div>
      </div>
      <!-- 待填充内容 -->
      <div></div>

      <!-- 攻略 直接引入html -->
      <div class="guide-container" v-if="hkj">
          <!-- <div class="guide-label">商品参与奖励活动</div> -->
          <div v-html="hkj.course"></div>
          <div>购买链接: {{ hkj.shortCode }}</div>
          <img @click="handleDownLoadImg(hkj.rqCode)" style="width: 155px;height: 180px;display: block;position: relative; margin: 0 auto;" :src="hkj.rqCode" mode=""/>
          <div style="text-align: center;">（点击下载二维码）</div>
      </div>
      <!-- 按钮栏 -->
      <div class="btn-wrap max-width" v-if="hkj">
          <div v-if="hkj" class="btn-buy btn bg-orange" @click="handleBack">
              <span>信息反馈</span>
          </div>
          <div v-if="hkj" class="btn-link btn txt-orange" @click="handleCopy">
              <span class="txt-orange">复制</span>
          </div>
          <!-- <div v-if="!hkj" class="btn-link btn bg-orange" @click="handleGetCourse">
              <span class="txt-white">获取攻略</span>
          </div> -->
      </div>
      <!-- 悬浮按钮用于生成攻略 -->
      <div class="levitated-sphere" v-if="!hkj" @click="handleGetCourse">
        <img src="../assets/images/gonglue.png" alt="">
      </div>
      <!-- 引入弹出组件 -->
      <feed-back :sku-id="skuId" v-if="visablePop" @close="handleCloseFeedBack"></feed-back>
  </div>
</template>
<script>
// import 'swiper/css/bundle'
import { getProductDetail } from '@/services/product'
// import { Swiper, SwiperSlide } from 'swiper/vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import feedBack from '@/components/feedback/index.vue'
import { downloadImg } from '@/services/download'
import { loginStore } from '@/store';

let vm = null
export default {
  components: {
    Swiper,
    SwiperSlide,
    feedBack,
  },
  data() {
    return {
      swiperOptions: {
        loop: false, // 循环模式选项
        autoplay: {
            delay: 3000, // 自动切换时间间隔
            disableOnInteraction: false // 用户操作后是否停止自动切换
        },
        on: {
            slideChange() {
                // console.log(this.activeIndex)
                vm.currentIndex = this.activeIndex
            }
        }
      },
      product: {
        imageInfo: {
          imageList: []
        },
        skuTagList: [],
        priceInfo: {
          lowestPrice: '',
          lowestCouponPrice: '',
          price: '',
          lowestPriceType: ''
        },
        shopInfo: {
          shopName: ''
        },
        commissionInfo: {
          commission: '',
          commissionShare: ''
        }
      },
      interval: 3000,
      duration: 500,
      currentIndex: 0,
      totalLength: '',
      hkj: null,
      skuId: null,

      /** 弹出组件数据 */
      visablePop: false,
      resizeStyle: {},
      loginType: ''

    }
  },
  computed: {
    imgStyle() {
        return this.resizeStyle
    }
  },
  created() {
    vm = this
    this.skuId = this.$route.params.skuId
    getProductDetail({ skuId: this.skuId, fields: '' }).then(res => {
      this.product = res.data
      this.totalLength = this.product.imageInfo.imageList.length
    })
    this.loginType = loginStore.getLoginType()
  },
  mounted() {
    window.addEventListener('resize', () => {
        this.getResizeSize()
    })
  },
  methods: {
    getResizeSize() {
        let wd = document.querySelector('body').clientWidth + 'px'
        this.resizeStyle = {
            width: wd,
            height: wd
        }
    },
    onSlideChange(e) {
      console.log('onSlideChange',e)
    },
    onSwiper(swiper) {
      this.swiper = swiper
      console.log('onSwiper', swiper)
    },
    handleCopy() {
      let d1 = this.hkj.course.replace(/<p.*?>/g,'').replace(/<\/p>/g,'\n').replace(/<a.*?>/g,'').replace(/<br.*?>/g,'').replace(/<span.*?>/g,'').replace(/<\/a>/g,'').replace(/<\/span>/g,'').replace(/<img.*?>/g, '')
      d1 = d1+'\n'+'购买链接:' +this.hkj.shortCode + '\n'
      navigator.clipboard.writeText(d1).then(() => {
        this.$showToast({
            type: 'icon',
            toastSuccess: true,
            toastMessage: '复制成功！',
            duration: 2000 
        })
      }).catch(() => {
        this.$showToast({
            type: 'icon',
            toastSuccess: true,
            toastMessage: '复制失败！',
            duration: 2000 
        })
      })
    },
    handleDownLoadImg(e) {
        downloadImg(e)
    //   const filePath = e.currentTarget.dataset.src
    //   utils.downLoadImg(filePath, this)
    },
    handleGetCourse() {
      this.$showToast({
        type: 'loading',
        toastMessage: '正在加载数据...',
        duration: 2000 
    })
      getProductDetail({ skuId: this.skuId, fields: 'coupon' }).then(res => {
          this.hkj = res.data.hkj
      }).catch(() => {
      })
    },
    /**信息反馈 */
    handleBack() {
        this.visablePop = true
    },
    handleCloseFeedBack() {
        this.visablePop = false
    }
  }
}
</script>
<style scoped>
.mySwiper {
  width: 100%; /* 根据需要调整宽度 */
  height: 300px; /* 根据需要调整高度 */
}
/* pages/productDetail/index.wxss */
.detail-page{
    background-color: rgba(0, 0, 0, 0.05);
    /* height: 100vh; */
}
.img-container{
    position: relative;
}
.img-swiper{
    position: relative;
    /* height: 380px; */
}
.detail-img{
    width: 100%;
    height: 100%;
}
.image-list-index{
    width: 50px;
    height: 25px;
    line-height: 25px;
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    bottom: 30px;
    right: 0;
    color: white;
    font-size: 12px;
    text-align: center;
    z-index: 999;
}
.image-list-index span{
    font-size: 14px;
}
.image-list-span{
    position: absolute;
    bottom: 0;
    height: 25px;
    line-height: 25px;
    text-align: center;
    color: white;
    background-color: orange;
    opacity: 0.8;
    width: 100%;
    font-size: 12px;
    z-index: 99;
}
.bg-white{
    background-color: white;
}
.detail-card{
    background-color: white;
}
.price-container{
    padding: 10px 0 15px 0;
    border-bottom: 0.5px solid #ccc;
}
.txt-orange{
    color: var(--primary-color);
}
.price-and-num{
    display: flex;
    align-items: center;
}
.price-label{
    font-size: 12px;
}
.old-price{
    color: #aaaaaa;
    font-size: 12px;
    text-decoration: line-through;
    flex: 1;
}
.sale-num{
    position: relative;
    display: inline-block;
    font-size: 12px;
    width: 45px;
    position: relative;
}
.arrow::after{
    position: absolute;
    top: 5px;
    right: 0;
    content: '';
    width: 5px;
    height: 5px;
    border-top: 1px solid #000000;
    border-right: 1px solid #000000;
    transform: rotate(45deg);
}
.coupon-container{
    display: flex;
    margin-top: 5px;
}
.coupon-info{
    flex: 1;
    height: 22px;
    overflow: hidden;
}
.coupon-item{
    color: var(--primary-color);
    border: 1px solid var(--primary-color);
    border-radius: 4px;
    font-size: 12px;
    height: 14px;
    line-height: 14px;
    margin-right: 5px;
    display: inline-block;
    padding: 0 5px;
}
.coupon-more{
    width: 85px;
    font-size: 12px;
    position: relative;
}
.title-container{
    padding: 10px 0;
    /* border-bottom: 0.5px solid #cccccc; */
}
.good-replay{
    font-size: 12px;
}
.title-txt{
    display: inline-block;
    white-space: normal;
    height: 40px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
}
.income-container{
    margin-top: 5px;
    padding: 10px 10px 20px 10px;
}
.income-label{
    border-left: 3px solid var(--primary-color);
    display: inline-block;
    font-size: 14px;
    height: 14px;
    line-height: 14px;
    padding-left: 5px;
}
.income-price{
    margin-top: 5px;
}
.income-price span{
    /* margin-top: 10px; */
    font-size: 14px;
}
.guide-container{
    padding: 10px;
    margin-bottom: 60px;
}
.guide-container image{
    height: 160px;
    width: 165px;
    display: block;
    margin: 20px auto;
}
.guide-label{
    font-size: 14px;
}
.btn-wrap{
    position: fixed;
    background-color: #ffffff;
    bottom: 0;
    height: 50px;
    /* width: 100%; */
    border-top: 1px solid #cccccc;
    display: flex;
    z-index: 999;
    /* align-items: center; */
}
.btn{
    flex: 1;
    text-align: center;
    padding-top: 10px;
    color: white;
}
.wx-radio-input{
    display: none;
}
/** hack样式 解决获取到的html 的样式问题 */
.guide-container a{
    word-break: break-all;
}
.txt-white{
    color: white;
}
/** 悬浮球 */
.levitated-sphere img{
    width: var(--len60);
    height: var(--len30);
}
.levitated-sphere{
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: var(--len20);
    right: var(--len20);
    background-color: white;
    height: var(--len70);
    width: var(--len70);
    border-radius: 50% 50%;
    cursor: pointer;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
    z-index: 99999;
}
</style>